import { Injectable } from '@angular/core';
import { AuthService } from '../services/auth-service.service';
import { LoadingService } from '../services/loading.service';

@Injectable()
export class FileService {

  constructor(public auth: AuthService, public loadingService: LoadingService) {
  }


  downloadSecureFile(serverPath:string, fileName:string) {
    let anchor = document.createElement("a");
    document.body.appendChild(anchor);
    let headers = new Headers();
    this.loadingService.show(); // Manually show the spinner
    headers.append('Authorization', `Bearer ${this.auth.Token}`);
    fetch(serverPath, { headers })
      .then(response => response.blob())
      .then(blobby => {
        let objectUrl = window.URL.createObjectURL(blobby);

        anchor.href = objectUrl;
        anchor.download = fileName;
        anchor.click();
        window.URL.revokeObjectURL(objectUrl);
      })
      .then(() => {
        // Cleanup logic goes here, replacing finally
        this.loadingService.hide(); // Manually hide the spinner
        document.body.removeChild(anchor);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/file.service.ts